<template>
  <div class="where-to-buy-wrap">
    <WhereToBuyItem v-for="(item) in stores" :key="item.id" :store="item"/>
  </div>

</template>

<script>
import WhereToBuyItem from "@/components/WhereToBuyItem.vue";

export default {
  name: "WhereToBuy",
  components: {WhereToBuyItem},
  props: {
    stores: {
      type: Array
    }
  }
}
</script>


<style scoped lang="less">
.where-to-buy-wrap {
  & > * + * {
    margin-top: 6px;
  }
}
</style>